/* eslint-disable complexity */
/* eslint-disable no-inline-comments */
// Copyright (c) 2017 Deere & Company

import './dealer-recommendation.scss';
import React, {
    Component,
    PropTypes
} from 'react';

import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import AccordionState from '../../../shared/components/smart-accordion/state/accordion';
import DealerRecommendationConfirmModal from '../state/dealer-recommendation-confirm-modal';
import DealerRecommendationHandlers from './dealer-recommendation-handlers';
import DealerRecommendationModal from './dealer-recommendation-modal';
import DealerRecommendationsFacets from './dealer-recommendation-facets';
import DealerRecommendationsList from './dealer-recommendation-list';
import DuplicatePinPlateLinkPanel from '../../shared/components/duplicate-pin-plate-link';
import Facets from '../state/facets';
import {FormattedMessage} from 'react-intl';
import HighRentalDays from '../../search/components/high-rental-days';
import ProductReportLinks from '../../shared/components/product-report-links';
import ProductSearchBox from '../../shared/components/product-search-box';
import ProductsByCustomerLinkPanel from '../../shared/components/products-by-customer-link-panel';
import RefinableListWidgetWithExport from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export';
import SearchDropDown from '../../shared/state/search-by-dropdown';
import SearchFilters from '../../shared/state/search-filters';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import State from '../state';
import TabNavigation from '../../../shared/components/tab-navigation';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {getNavigationTabs} from '../../shared/services/product-navigation-helper';
import {getStore} from '../../../store-factory';
import {hasAccess} from '../../../shared/services/security';
import {hasPermission} from '../../../shared/services/privacy';
import {isEntitled} from '../../../shared/services/entitlements';

const filterOptions = [
    [
        'product',
        'pin'
    ]
];

const sortOptions = [
    {
        displayName: 'Default',
        path: ['default']
    },
    {
        displayName: 'PIN',
        path: [
            'product',
            'pin'
        ]
    },
    {
        displayName: 'CURRENT_DEALER_LOCATION',
        path: [
            'currentDealer',
            'location',
            'city'
        ]
    },
    {
        displayName: 'RECOMMENDATION_DATE',
        path: [
            'recommendation',
            'recommendationDate'
        ]
    },
    {
        displayName: 'RECOMMENDED_ACCOUNT',
        path: [
            'newDealer',
            'account'
        ]
    },
    {
        displayName: 'CUSTOMER',
        path: [
            'product',
            'customerSummary',
            'displayName'
        ]
    },
    {
        displayName: 'LAST_SEEN_AT_RESPONSIBLE_ACCOUNT',
        path: [
            'recommendation',
            'lastSeenAtResposibleAccount'
        ]
    }
];

function applyTransferApprovalFacets() {

    this.props.actions.updateTransferResultsWithFacets(false, 0);

}

function resetTransferApprovalFacets() {

    this.props.actions.resetTransferResults(this.props.facets.dealerAccountsFacet.allowedDealers);

}

function handleDealerFilterInput(text) {

    this.props.actions.updateDealerAccountFacetInput(text);

}

function updateTransferApprovalFacetItem(item, isSelected) {

    this.props.actions.updateTransferApprovalFacetItem(item, isSelected);

}

function toggleTransferApprovalFacetItems() {

    this.props.actions.toggleTransferApprovalFacetItems(this.props.facets.dealerAccountsFacet.allowedDealers);

}

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}

function handleAccordionToggle() {

    this.actions.toggleReportsAccordion();

}

function handleHighRentalDaysDownloadToExcel() {

    this.actions.highRentalDaysExportToExcel(
        this.user.settings,
        this.user.getLocale()
    );

}

function handleDownloadToExcel() {

    this.actions.exportToExcel(
        this.facets,
        this.user.getLocale()
    );

}

function handleDealerRecommendationModal() {

    this.actions.closeDealerRecommendationModal();

}

class DealerRecommendations extends Component {
    constructor(props) {

        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.handleUpdateDealerRecommendationFilterBy = this.handleUpdateDealerRecommendationFilterBy.bind(this);
        this.handleUpdateListFilterBy = this.handleUpdateListFilterBy.bind(this);
        this.handleOpenDealerRecommendationModal = this.handleOpenDealerRecommendationModal.bind(this);
        this.handleDealerRecommendationModalConfirmation = this.handleDealerRecommendationModalConfirmation.bind(this);

    }

    state = {
        confirmMessage: '',
        dealerRecommendationsLocal: null,
        indivdualActionDealer: null,
        isFilterSearchClicked: false,
        isModalOpen: false,
        title: '',
        type: ''
    };

    componentWillMount() {

        if (this.props.facets.dealerAccountsFacet.isInitialLoad || !this.props.facets.dealerAccountsFacet.selectedDealers.length) {

            this.props.actions.selectAllDealersOnInitialLoad(this.props.facets.dealerAccountsFacet.allowedDealers);

        }
        this.props.actions.updateTransferResultsWithFacets(true, 0);
        this.props.actions.resetSelectedDealerRecommendations();
        this.props.actions.highOnRentalDays(this.props.user.settings);

        if (hasAccess(this.props.security, 'PRT', 'PRT_FACTORY_USER_PIN_PLATE')) {

            this.props.actions.updateFactoryDuplicatePinPlateResults();

        }

    }

    handleClose() {

        this.setState({isModalOpen: false});

    }

    handleUpdateDealerRecommendationFilterBy(account, value, searchType) {

        this.props.actions.updateRecommendationListFilterBy(account, value, searchType)
            .then(payload => {

                this.setState({dealerRecommendationsLocal: payload});

            });

    }

    handleUpdateListFilterBy(value, type) {

        this.props.actions.updateListFilterBy(value, type);
        this.setState({isFilterSearchClicked: true});
        if (value.length < 17) {

            this.setState({dealerRecommendationsLocal: null});
            this.setState({isFilterSearchClicked: false});

        }

    }

    handleOpenDealerRecommendationModal(message, title, type, dealerRecommendation) {

        this.props.actions.openDealerRecommendationModal(type);
        const indivdualActionDealer = dealerRecommendation ? [dealerRecommendation] : null;

        this.setState({confirmMessage: message, indivdualActionDealer, isModalOpen: true, title, type});

    }

    handleDealerRecommendationModalConfirmation(type, commentsDealerRecommendation) {

        let filteredDealer;

        filteredDealer = this.state.indivdualActionDealer;

        this.setState({
            confirmMessage: '',
            indivdualActionDealer: null,
            isModalOpen: false,
            title: '',
            type: ''
        });

        if (filteredDealer === null) {

            filteredDealer = this.state.dealerRecommendationsLocal ? this.state.dealerRecommendationsLocal.elements.filter(am => this.props.selectedDealerRecommendations.find(rm => rm === am.id)) : this.props.dealerRecommendations.elements.filter(am => this.props.selectedDealerRecommendations.find(rm => rm === am.id));

        }

        if (type === 'review') {

            this.props.actions.updateReview(filteredDealer, commentsDealerRecommendation);
            this.props.actions.closeDealerRecommendationModal();
            this.setState({dealerRecommendationsLocal: null});

        } else if (type === 'transfer') {

            this.props.actions.updateTransferRequest(filteredDealer, commentsDealerRecommendation);
            this.props.actions.closeDealerRecommendationModal();
            this.setState({dealerRecommendationsLocal: null});

        } else if (type === 'transferAll') {

            this.props.actions.transferAllDealerRecommendation(commentsDealerRecommendation);
            this.props.actions.closeDealerRecommendationModal();
            this.setState({dealerRecommendationsLocal: null});

        }

    }

    render() {

        const countObject = {
            dealerRecommendations: this.props.dealerRecommendations.totalElements,
            factoryDuplicatePinPlateCount: this.props.duplicatePinPlateCount,
            machineStatusUpdates: this.props.machineStatusUpdateCount,
            productSearch: this.props.searchResultsCount,
            registrationReview: this.props.registrationReviewCount,
            transferApproval: this.props.transferApprovalsCount
        };

        let sortedCollection;

        sortedCollection = this.state.dealerRecommendationsLocal ? [...this.state.dealerRecommendationsLocal.elements] : [...this.props.dealerRecommendations.elements];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, filterOptions, sortedCollection);

        return (
            <div>
                <div className='dealer-recommendations'>
                    <aside>
                        <DealerRecommendationsFacets
                            dateFormat={this.props.dateFormat}
                            dealerAccountsFacet={this.props.facets.dealerAccountsFacet}
                            onApply={this::applyTransferApprovalFacets}
                            onCheckboxListChange={this::updateTransferApprovalFacetItem}
                            onInputChange={this::handleDealerFilterInput}
                            onReset={this:: resetTransferApprovalFacets}
                            onToggleAll={this::toggleTransferApprovalFacetItems}
                        />
                        <HighRentalDays
                            highRentalDaysCount={this.props.highRentalDaysCount}
                            onExport={this.props::handleHighRentalDaysDownloadToExcel}
                        />
                        {!this.props.user.privacy.customerPrivate &&
                        <ProductsByCustomerLinkPanel/>
                        }
                        {isEntitled(getStore().getState().user.entitlements, 'duplicatepins') > 0 &&
                        <DuplicatePinPlateLinkPanel/>
                        }
                        <div className='report-links'>
                            <ProductReportLinks
                                onAccordionToggle={this.props::handleAccordionToggle}
                                reportsAccordion={this.props.reportsAccordion}
                                reportsRoutes={this.props.reportsRoutes}
                            />
                        </div>
                    </aside>
                    <main>
                        <div className='primary-actions'>
                            {hasAccess(this.props.security, 'PRT', 'PRT_REGISTER_PRODUCT') && hasPermission(this.props.user.privacy, 'registrationNotAllowed') &&
                            <a
                                className='primary-action'
                                href={'#/products/register-product'}
                            >
                                <FormattedMessage id='REGISTER_PRODUCT'/>
                            </a>
                        }
                        </div>
                        <ProductSearchBox
                            handleSearch={this.props::handleSearch}
                            searchByDropDown={this.props.searchByDropDown}
                            searchQueryString={this.props.searchQueryString}
                            updateSearchDropDown={this.props.actions.updateSearchDropDown}
                            updateSearchQueryString={this.props.actions.updateSearchQueryString}
                        />
                        <div className='dealer-recommendations-search-tabs'>
                            <TabNavigation
                                tabs={getNavigationTabs(countObject, this.props.hasSearchResults, this.props.security)}
                            />
                        </div>
                        <DealerRecommendationsList
                            dealerRecommendations={sortedCollection}
                            handleDealerChange={(event, dealerRecommendation) => this.props.actions.updateDealerRecommendationCheckBox(dealerRecommendation, event.target.checked)}
                            handleMore={count => {

                                this.props.actions.updateTransferResultsWithFacets(false, count, true);

                            }}
                            isSearchResultEmpty={!this.state.dealerRecommendationsLocal}
                            openDealerRecommendationModal={this.handleOpenDealerRecommendationModal}
                            selectedDealerRecommendations={this.props.selectedDealerRecommendations}
                            totalElements={this.state.dealerRecommendationsLocal ? this.state.dealerRecommendationsLocal.totalElements : this.props.dealerRecommendations.totalElements}
                            totalElementsCount={this.props.dealerRecommendations.totalElements}
                            totalPages={this.state.dealerRecommendationsLocal ? this.state.dealerRecommendationsLocal.totalPages : this.props.dealerRecommendations.totalPages}
                            updateCommentAction={this.props.actions.updateRecommendationComment}
                        >
                            <DealerRecommendationHandlers
                                dealerRecommendations={this.props.dealerRecommendations.elements}
                                openDealerRecommendationModal={this.handleOpenDealerRecommendationModal}
                                selectAllActionHandler={() => this.props.actions.toggleSelectAll(this.state.isFilterSearchClicked ? sortedCollection : this.props.dealerRecommendations.elements)}
                                selectedDealerRecommendations={this.props.selectedDealerRecommendations}
                            />
                            <RefinableListWidgetWithExport
                                accounts={this.props.facets.dealerAccountsFacet.selectedDealers}
                                hasResults={this.props.dealerRecommendations.elements.length > 0}
                                isAPIBasedSearchFilter={true}
                                onExport={this.props::handleDownloadToExcel}
                                onFilterByChange={this.handleUpdateListFilterBy}
                                onSearchFilterChange={this.handleUpdateDealerRecommendationFilterBy}
                                onSortByChange={this.props.actions.updateListSortBy}
                                onSortDirectionChange={this.props.actions.updateListSortDirection}
                                searchFilters={this.props.searchFilters}
                                searchType={'PIN'}
                                sortOptions={sortOptions}
                                type={State}
                            />
                        </DealerRecommendationsList>
                        <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                    </main>
                </div>

                <DealerRecommendationModal
                    closeDealerRecommendationModal={this.props::handleDealerRecommendationModal}
                    dealerRecommendationModal={this.props.dealerRecommendationConfirmModal}
                    onConfirmation={this.handleDealerRecommendationModalConfirmation}
                />
            </div>
        );

    }
}

DealerRecommendations.displayName = 'DealerRecommendations';
DealerRecommendations.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    dateFormat: PropTypes.string.isRequired,
    dealerRecommendationConfirmModal: PropTypes.instanceOf(DealerRecommendationConfirmModal),
    dealerRecommendations: PropTypes.instanceOf(Object).isRequired,
    duplicatePinPlateCount: PropTypes.number,
    facets: PropTypes.instanceOf(Facets).isRequired,
    hasSearchResults: PropTypes.bool.isRequired,
    highRentalDaysCount: PropTypes.number.isRequired,
    machineStatusUpdateCount: PropTypes.number,
    registrationReviewCount: PropTypes.number,
    reportsAccordion: PropTypes.instanceOf(AccordionState).isRequired,
    reportsRoutes: PropTypes.object.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchDropDown),
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    searchResultsCount: PropTypes.number.isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    selectedDealerRecommendations: PropTypes.instanceOf(Object).isRequired,
    transferApprovalsCount: PropTypes.number,
    user: PropTypes.instanceOf(User).isRequired

};

export default DealerRecommendations;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/components/dealer-recommendation.js